// English — baseline dictionary. Every other language file must mirror this
// exact key structure; any key missing in another language silently falls
// back to the English string here (see lib/i18n/index.js `t()`).
export default {
  common: {
    save: "Save",
    cancel: "Cancel",
    back: "Back",
    submit: "Submit",
    loading: "Loading…",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    close: "Close",
    search: "Search",
    all: "All",
    done: "Done",
    logout: "Log Out",
    language: "Language",
    selectLanguage: "Select your language",
    saving: "Saving…",
    saved: "Saved",
    viewAll: "View all",
    filters: "Filters",
  },
  nav: {
    home: "Home",
    installs: "Installs",
    requests: "Requests",
    orders: "Orders",
    profile: "Profile",
    leads: "Leads",
    service: "Service",
    payouts: "Payouts",
    toolkit: "Toolkit",
  },
  profile: {
    yourAccount: "Your account",
    title: "Profile.",
    city: "City",
    state: "State",
    pinCode: "PIN Code",
    pinCodeHelp: "Your Region is the Permissible Territory this PIN code belongs to.",
    upiId: "UPI ID (for payouts)",
    saveProfile: "Save profile",
    preferredLanguage: "Preferred language",
    logoutConfirm: "Are you sure you want to log out?",
    linkedAddresses: "Linked Addresses",
    noAddresses: "No saved addresses yet.",
    referFriend: "Refer a Friend",
    referFriendSub: "Share your code — earn rewards when they go solar.",
    myReferrals: "My Referrals",
    shareFriend: "Share with a friend",
    secureNote: "Your data is verified via secure phone OTP — no password to remember or lose.",
    toolkit: "Toolkit",
    incentiveSchemes: "Incentive schemes",
  },
  tickets: {
    myRequests: "My Requests",
    raiseComplaint: "Raise a Complaint",
    cancelRequest: "Cancel Request",
    cancelConfirmTitle: "Cancel this request?",
    cancelConfirmBody: "We'll stop work on this service request. You can always raise a new one later.",
    cancelledToast: "Request cancelled",
    keepRequest: "No, keep it",
    noRequests: "No service requests yet.",
    statusOpen: "Open",
    statusInProgress: "In Progress",
    statusOnHold: "On Hold",
    statusActionNeeded: "Action Needed",
    statusCompleted: "Completed",
    statusClosed: "Closed",
    statusCancelled: "Cancelled",
    statusDropped: "Dropped",
    filterAll: "All",
    filterActive: "Active",
    filterResolved: "Resolved",
    nonServiceable: "Non Serviceable Area",
    raisedOn: "Raised on",
    ticketNumber: "Ticket",
    wipInstall: "WIP Install",
    raisedByYou: "Raised by you",
    raisedByTeam: "Raised by our team",
    timeline: "Timeline",
    pending: "Pending",
    resolutionSummary: "Resolution Summary",
    youRatedPrefix: "You rated this",
    howWasResolution: "How was the resolution?",
    submitFeedback: "Submit Feedback",
  },
  home: {
    greeting: "Hi",
    newInstallation: "New Installation",
    raiseComplaint: "Register a Complaint",
    welcomeBack: "Welcome back",
    customerSubtitle: "Your solar journey with Purvodaya, all in one place.",
  },
  sc: {
    requestsTitle: "Service Requests",
    requestsForCustomers: "for your customers",
    kpiOpen: "Open",
    kpiResolved: "Resolved",
    kpiInProblem: "In Problem",
    raiseRequest: "Raise Service Request",
    slaBreached: "SLA breached",
    viewPhotos: "View photos",
    hidePhotos: "Hide photos",
    noRequestsWindow: "No service requests in this window.",
  },
};
